module.exports = __webpack_public_path__ + "static/img/z-8.080fc81b.png";